import { render } from "./MovieSearch.vue?vue&type=template&id=5bdb661a&scoped=true"
const script = {}

import "./MovieSearch.vue?vue&type=style&index=0&id=5bdb661a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdb661a"]])

export default __exports__